










































































































































import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class List extends Vue {
  get type() {
    return this.$route.query.account_type;
  }

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }
}
